module.exports = __webpack_public_path__ + "static/img/company-logo.d72dc7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/004-simtec/company-logo.png
// module id = a3ig
// module chunks = 1